import axios from "axios";

// Ported from sge_infantil_web/src/services/rhApi.js — client for the
// separate HR backend (hr-backend-service) that owns worker self-service
// lookups (e.g. "Marcar Presença" identifying a worker by contact). This is
// a different deployment from services/api.js (sge_infantil_core), which is
// what actually records the attendance itself (services/attendance.js).
export const baseURL = "https://api.jumbatec.com/hr/";

const rhApi = axios.create({
  baseURL,
  rejectUnauthorized: false,
});

// hr-backend-service wraps every response as { success, message, data } —
// unwrap it here so callers just get response.data like services/api.js.
rhApi.interceptors.response.use(
  (response) => {
    if (response?.data && response.data.data !== undefined) {
      return { ...response, data: response.data.data };
    }
    return response;
  },
  (error) => Promise.reject(error),
);

export default rhApi;
